import {
  faCheck,
  faChevronLeft,
  faPlay,
  faFile,
  faTimes
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import styled from "styled-components";
import GuideImg1 from "../../../../../assets/images/guideImg1.png";
import GuideImg3 from "../../../../../assets/images/guideImg3.png";
import GuideImg4 from "../../../../../assets/images/guideImg4.png";
import { ChangeEvent, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import ImageModal from "./Modal/ImageModal";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { GameProposalProjectInfoDetailsAPI, GameProposalProjectInfoSaveApi, LabsGameModificationAPI, LabsGameProposalProjectInfoApprovedModificationAPI } from "../../TestManagementApi";
import { useRecoilValue } from "recoil";
import { gameProposalIdState } from "src/recoil/atoms/gameProposalState";
import { SuccessModal } from '../components/SuccessModal';
import { GameProposalStepAvailabilityAPI } from "../AddTestApi";
import CustomNavLink from '../components/CustomNavLink';
import { GameProposalStepAvailabilityResponse } from "../../types/Response";
import { CheckPageMoveModal } from '../components/CheckPageMoveModal';
import {
  addUploadState,
  uploadFileToS3,
  removeUploadState,
  formatFileSize
} from '../../../../common/UploadProgressPortal';
import { parsingPlatformText } from "../../../../../utils/platformUtils";

const Main = styled.main`
    background-color: #f8f9fa;
  width: 100%;
  min-width: 1280px;
  max-width: 1920px;
  height: 100vh;
  padding-left: 195px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const TopWrapper = styled.div`
  padding-left: 80px;
  border-bottom: 1px solid #ededed;ㅁ
  min-height: 157px;
  display: flex;
  flex-direction: column;
  gap: 34px;
  padding-top: 30px;
  background-color: #f8f9fa;
  position: sticky;
  top: 0;
  z-index: 1;
`;

const TopContainer = styled.div`
  // width: 1280px;
  width: 95%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TopTitle = styled.span`
  color: #2282e9;
  font-size: 20px;
  font-weight: 700;
`;

const BtnContainer = styled.div`
  display: flex;
  gap: 20px;
`;

const TopBtn = styled.button`
  width: 160px;
  height: 55px;
  border-radius: 5px;
  background-color: white;
  border: 1px solid #ededed;
  color: #c0c0c0;
  font-weight: 600;
`;

const PreviewBtn = styled(TopBtn)`
  color: white;
  background-color: #2282e9;
`;
interface SaveBtnProps {
  isActive: boolean;
}
const SaveBtn = styled(TopBtn) <SaveBtnProps>`
  color: ${({ isActive }) => isActive ? "#2282e9" : "#c0c0c0"};
  border: 1px solid ${({ isActive }) => isActive ? "#2282e9" : "#c0c0c0"};
  border-radius: 5px;
  cursor: ${({ isActive }) => isActive ? "pointer" : "not-allowed"};
  opacity: ${({ isActive }) => isActive ? "1" : "0.6"};
`;

const NavCotainer = styled.div`
  color: #c0c0c0;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  width: 1280px;
  height: 37px;
`;

const ContentWrapper = styled.div`
  padding-top: 70px;
  padding-left: 125px;
  padding-bottom: 309px;
  overflow-y: auto;
  height: calc(100vh - 157px);
`;

const Title = styled.span`
  display: block;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
`;

const Comment = styled.span`
  display: block;
  line-height: 26px;
  color: #9f9f9f;xz
  margin-bottom: 20px;
  padding-bottom: 10px;
`;

const SelectContainer = styled.div`
  position: relative;
  cursor: pointer;
`;

const SelectBox = styled.div`
  width: 730px;
  height: 71px;
  border-radius: 5px;
  background-color: white;
  border: 1px solid #2282e9;
  padding: 0px 40px;
  position: relative;
  margin-bottom: 16px;
  z-index: 0;
  position: relative;
`;
const PrimeTitle = styled.span`
  font-weight: 600;
  font-size: 14px;

`;
const SelectText = styled.span`
  font-size: 14px;
  color: #9f9f9f;
  font-weight: 500;
  position: absolute;
  top: 26px;
  left: 40px;
  display: flex;
`;

const PlatformContainer = styled.div`
  width: 730px;
  height: 207px;
  background-color: white;
  border-radius: 5px;
  border: 1px solid #2282e9;
  position: absolute;
  top: 70px;
  z-index: 5;
  :not(:last-child) {
    border-bottom: 1px solid #ededed;
  }
  overflow: hidden;
`;

const Platform = styled.div`
  padding: 0px 40px;
  height: 69px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #9f9f9f;
  cursor: pointer;
  &:hover {
    background-color: #2282e9;
    color: white;
  }
`;

const GenreContainer = styled.div`
  width: 730px;
  height: 207px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background-color: white;
  border-radius: 5px;
  overflow: hidden;
  position: absolute;
  top: 71px;
  z-index: 5;
  font-weight: 500;
`;

const Genre = styled.div<{ isSelected?: boolean }>`
  width: 100%;
  font-size: 12px;
  color: ${props => props.isSelected ? 'white' : '#9f9f9f'};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ededed;
  background-color: ${props => props.isSelected ? '#2282e9' : 'white'};
  &:hover {
    background-color: #2282e9;
    color: white;
  }
`;

const Input = styled.input`
  width: 730px;
  height: 71px;
  border-radius: 5px;
  background-color: white;
  border: 1px solid #2282e9;
  padding: 0px 40px;
  position: relative;
  margin-bottom: 16px;
  box-sizing: border-box;
  color: #2282e9;
  font-size: 14px;
  outline: none;
  ::placeholder {
    color: #9f9f9f;
  }
`;

const TextArea = styled.textarea`
  width: 730px;
  height: 280px;
  border-radius: 5px;
  background-color: white;
  border: 1px solid #2282e9;
  padding: 30px 40px;
  position: relative;
  box-sizing: border-box;
  resize: none;
  font-size: 14px;
  color: #2282e9;
  outline: none;
  ::placeholder {
    color: #9f9f9f;
  }
  // font-weight: 500;
`;

const Bar = styled.div`
  width: 1280px;
  height: 1px;
  background-color: #ededed;
  margin-top: 70px;
  margin-bottom: 70px;
`;

const GuideBox = styled.div`
  width: 730px;
  height: 236px;
  background-color: white;
  border-radius: 5px;
  padding: 22px 22px 22px 40px;
  display: flex;
  gap: 67px;
  // margin-bottom: 70px;
  border: 1px solid #ededed;
`;

const GuideTitle = styled.span`
  display: block;
  font-weight: 600;
  margin-bottom: 16px;
`;

const GuideDesc = styled.span`
  font-size: 12px;
  color: #797979;
  line-height: 20px;
`;

const GuideImg = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  color: #797979;
  font-size: 12px;
`;

const AddImg = styled.label`
  width: 730px;
  min-height: 110px;
  // height: 110px;
  border: 1px solid #2282e9;
  border-radius: 5px;
  background-color: white;
  color: #2282e9;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const Plus = styled.span`
  color: #2282e9;
  font-size: 28px;
`;

const SubTitle = styled.span`
  display: block;
  color: #4b4b4b;
  font-weight: 500;
  margin-bottom: 10px;
`;

const LinkInputContainer = styled.div<{ disabled?: boolean }>`
  width: 730px;
  height: 65px;
  border-radius: 5px;
  background-color: white;
  // border: 1px solid #2282e9;
border: 1px solid ${({ disabled }) => disabled ? '#8E8E8E' : '#2282e9'};
  padding: 0px 20px;
  font-size: 14px;
  // color: #2282e9;
  color: ${({ disabled }) => disabled ? '##8E8E8E' : '#8E8E8E'};
  display: flex;
  align-items: center;
  // margin-bottom: 16px;
`;

const LinkLabel = styled.span`
  width: 180px;  // 고정 픽셀 너비로 변경 (모든 텍스트를 수용할 수 있게)
  min-width: 180px; // 최소 너비 설정으로 일관성 유지
  display: inline-block;
`;

const LinkBar = styled.div`
  width: 1px;
  height: 33px;
  background-color: #ededed;
  margin: 0 20px; // 좌우 여백 일관되게 설정
`;

const LinkInput = styled.input<{ disabled?: boolean }>`
  width: 100%;
  // margin-left: -0px;
  // padding-left: -100%;
  font-size: 14px;
  font-weight: 500;
  color: #2282e9;
  outline: none;
  border: none;
  background-color: white;
`;

const CommentBlue = styled.span`
  display: block;
  font-size: 13px;
  color: #2282e9;
  line-height: 20px;
`;

const GenreBadgeContainer = styled.span`
  font-size: 14px;
  font-weight: 500;
  display: flex;
  height: 100%;
  align-items: center;
  gap: 14px;
`;

const GenreBadge = styled.div`
  padding: 10px 20px;
  background-color: #2282e9;
  color: white;
  border-radius: 50px;
  cursor: pointer;
  &:hover {
    background-color: #1a6abc;
  }
  
`;

const Count = styled.div`
  width: 730px;
  display: flex;
  justify-content: end;
  color: #c0c0c0;
  font-weight: 500;
  position: absolute;
  bottom: 16px;
  right: 30px;
`;

const TextAreaContainer = styled.div`
  width: 730px;
  position: relative;
  // margin-bottom: 70px;
`;

const DirectionContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 40px;
`;

const Direction = styled.label`
  width: 359px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background-color: white;
  color: #555555;
  cursor: pointer;

  input[type="radio"]:checked + & {
    background-color: #2282e9;
    color: white;
  }
`;

const PointSpan = styled.span`
  position: absolute;
  color: #2282e9;
  font-weight: 500;
  font-size: 14px;
  // bottom: px;
  
  right: 30px;
`;

const ThumbnailImg = styled.img`
  width: 80px;
  height: 80px;
`;

const BackgroundImg = styled.img`
  width: 142px;
  height: 80px;
`;

const ImgChangeBtn = styled.label`
  cursor: pointer;
  width: 173px;
  height: 37px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  border: 1px solid #ededed;
  color: #797979;
  font-weight: 500;
  font-size: 14px;
  margin-left: 20px;
`;

const ImagesWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px;
`;

const ImagesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-left: 18px;
  width: 450px;
  min-height: 80px;
  max-height: 170px;
  overflow-y: auto;
`;

const DisabledContainer = styled.div`
  width: 730px;
  height: 65px;
  border-radius: 5px;
  background-color: white;
  border: 1px solid #ededed;
  padding: 0px 20px;
  font-size: 14px;
  color: #c0c0c0;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

const DisabledInput = styled.input`
  font-size: 14px;
  font-weight: 500;
  color: #c0c0c0;
  outline: none;
  border: none;
  background-color: white;
`;

const DisabledAddImg = styled.label`
  width: 730px;
  height: 110px;
  border: 1px solid #ededed;
  border-radius: 5px;
  background-color: white;
  color: #c0c0c0;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  cursor: pointer;
  margin-bottom: 40px;
`;

const DisabledPlus = styled.span`
  color: #c0c0c0;
  font-size: 28px;
`;

// 인게임 이미지를 위한 스타일 컴포넌트 추가
const PreviewIngameImg = styled.img`
  width: 142px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
`;

const FileList = styled.div`
  margin-top: 10px;
`;

const FileItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 5px;
  margin-bottom: 10px;
  border: 1px solid #e9ecef;
`;

const FileInfo = styled.div`
  display: flex;
  align-items: center;
  // justify-content: column;
`;

const FileIcon = styled(FontAwesomeIcon)`
  color: #2282e9;
  font-size: 18px;
`;

const FileName = styled.span`
  margin-left: 10px;
  font-weight: 500;
`;

const FileSize = styled.span`
  color: #9f9f9f;
  margin-left: 10px;
`;

const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #ff6b6b;
  cursor: pointer;
`;


interface Genre {
  id: string;
  content: string;
}

const genre = [
  { id: "TRPG_GAME", content: "TRPG" },
  { id: "RPG_GAME", content: "RPG" },
  { id: "ADVENTURE_GAME", content: "어드벤처 게임" },
  { id: "SANDBOX_GAME", content: "샌드박스" },
  // { id: "EVENT_GAME", content: "이벤트" },
  { id: "ACTION_GAME", content: "액션 게임" },
  { id: "ROGUE_LITE_GAME", content: "로그라이트" },
  { id: "SHOOTING_GAME", content: "슈팅 게임" },
  { id: "AOS_GAME", content: "AOS 게임" },
  { id: "RTS_GAME", content: "RTS 게임" },

  { id: "DEFENSE_GAME", content: "디펜스" },
  { id: "TURN_BASE_GAME", content: "턴제 게임" },

  { id: "STRATEGY_GAME", content: "전술" },
  { id: "MANAGEMENT_GAME", content: "경영(타이쿤)" },
  { id: "SIMULATION_GAME", content: "시뮬레이션" },

  { id: "MERGE_GAME", content: "머지(merge-합성)" },
  { id: "FARMING_GAME", content: "농사" },

  { id: "PUZZLE_GAME", content: "퍼즐 게임" },
  { id: "ARCADE_GAME", content: "아케이드" },
  { id: "RACING_GAME", content: "레이싱 게임" },
  { id: "SPORTS_GAME", content: "스포츠 게임" },
  { id: "IDLE_TYPE_GAME", content: "방치형" },
  { id: "CASUAL", content: "캐주얼" },
  { id: "NONE", content: "선택안함" }
];

const TooltipContainer = styled.div`
  position: relative;
  display: inline-flex;  // flex로 변경
  align-items: center;   // 중앙 정렬 추가
  width: 165px;
  height: 100%;         // 100%로 변경하여 부모 높이에 맞춤
`;

const Tooltip = styled.div<{ disabled?: boolean }>`
  visibility: hidden;
  position: absolute;
  bottom: calc(100% + 8px);  // 위치 조정
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 12px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 1000;
  
  ${TooltipContainer}:hover & {
    visibility: ${props => !props.disabled ? 'hidden' : 'visible'};
  }

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.8) transparent transparent transparent;
  }
`;


// 장르 ID를 받아서 해당 content를 반환하는 함수
const getGenreContentById = (id: string): string => {
  const foundGenre = genre.find(item => item.id === id);
  return foundGenre ? foundGenre.content : "알 수 없는 장르";
};

// 장르 ID 배열을 받아서 Genre[] 객체 배열로 변환하는 함수
const parsingGenreText = (genreIds: string[] = []): Genre[] => {
  return genreIds.map(id => {
    const foundGenre = genre.find(item => item.id === id);
    return foundGenre ? { id: foundGenre.id, content: foundGenre.content } : { id, content: "알 수 없는 장르" };
  });
};

interface FormattedData {
  [key: string]: string | string[] | null | number | boolean;
  platform: string;
  gameName: string;
  genres: string[];
  description: string;
  cbtDescription: string;
  thumbnailImageUrl: string | null;
  ingameImageUrls: string[];
  backgroundImageUrl: string | null;
  surveyBackgroundImageUrl: string | null;
  playStoreLink: string;
  appStoreLink: string;
  pcDownloadLink: string;
  missionDescription: string;
  phaseOneExampleImageUrl: string | null;
  reward: string;
  phaseOneExampleHorizontal: string | null;
  hasThumbnailImage: boolean;
  hasBackgroundImage: boolean;
  hasSurveyBackgroundImage: boolean;
  hasIngameImages: boolean;
  hasPhaseOneExampleImage: boolean;
  hasApkFiles: boolean;
  hasExeFiles: boolean;
}

export default function AddTestPhase2() {
  const queryClient = useQueryClient();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const { gameProposalId } = useParams();
  const navigate = useNavigate();

  console.log(`phase2 - gameProposalId: `, gameProposalId);

  const { data: gameProposalProjectInfoDetailsData } = useQuery({
    // console.log(gameProposalProjectInfoDetailsData.)
    queryKey: ["gameProposalProjectInfoDetails", gameProposalId],
    queryFn: async () => {
      const response = await GameProposalProjectInfoDetailsAPI(Number(gameProposalId));
      return response.data;
    },
    enabled: true,
    refetchOnMount: true,
    staleTime: 0,
  });

  const MAX_FILES = 5;
  const MAX_SIZE = 10 * 1024 * 1024; // 5MB

  // 파일 업로드 관련 상태 - 로컬로 유지
  const [uploadFiles, setUploadFiles] = useState<File[]>([]);
  const [apkFiles, setApkFiles] = useState<File[]>([]);
  const [exeFiles, setExeFiles] = useState<File[]>([]);
  const { register, setValue, getValues, watch } = useForm();
  const [platform, setPlatform] = useState<string | null>(null);
  const [openPlatform, setOpenPlatform] = useState(false);
  const [genres, setGenres] = useState<Genre[]>([]);
  const [openGenre, setOpenGenre] = useState(false);

  const [description, setDescription] = useState<string>("");
  const [cbtDescription, setCbtDescription] = useState<string>("");

  const [imageModal, setImageModal] = useState(false);

  const [thumbnailImage, setThumbnailImage] = useState<File | undefined>();
  const [backgroundImage, setBackgroundImage] = useState<File | undefined>();
  const [surveyBackgroundImage, setSurveyBackgroundImage] = useState<
    File | undefined
  >();
  const [ingameImages, setIngameImages] = useState<File[]>([]);
  const [phaseOneExampleImage, setPhaseOneExampleImage] = useState<
    File | undefined
  >();

  const [thumbnailImageUrl, setThumbnailImageUrl] = useState<string | null>(null);
  const [backgroundImageUrl, setBackgroundImageUrl] = useState<string | null>(null);
  const [surveyBackgroundImageUrl, setSurveyBackgroundImageUrl] = useState<string | null>(null);
  const [ingameImageUrls, setIngameImageUrls] = useState<string[]>([]);

  const [phaseOneExampleImageUrl, setPhaseOneExampleImageUrl] = useState<string | null>(null);

  const [rewardValue, setRewardValue] = useState<string>("1000");
  // Add a state to track the selected direction
  const [selectedDirection, setSelectedDirection] = useState<string | null>(null);

  // APK 파일 선택 핸들러
  const handleApkFileSelect = () => {
    if (isDisabled) return;
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.apk,.zip';
    fileInput.style.display = 'none';

    fileInput.onchange = (e: Event) => {
      const target = e.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        const selectedFiles = Array.from(target.files);

        // APK 파일 상태 업데이트
        setApkFiles(prev => [...prev, ...selectedFiles]);

        // 전역 상태 업데이트
        addUploadState(selectedFiles);
      }
    };

    document.body.appendChild(fileInput);
    fileInput.click();

    setTimeout(() => {
      document.body.removeChild(fileInput);
    }, 500);
  };

  // EXE 파일 선택 핸들러
  const handleExeFileSelect = () => {
    if (isDisabled) return;
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.exe,.zip';
    fileInput.style.display = 'none';

    fileInput.onchange = (e: Event) => {
      const target = e.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        const selectedFiles = Array.from(target.files);

        // EXE 파일 상태 업데이트
        setExeFiles(prev => [...prev, ...selectedFiles]);

        // 전역 상태 업데이트
        addUploadState(selectedFiles);
      }
    };

    document.body.appendChild(fileInput);
    fileInput.click();

    setTimeout(() => {
      document.body.removeChild(fileInput);
    }, 500);
  };

  // APK 파일 삭제 핸들러
  const handleRemoveApkFile = (index: number) => {
    if (isDisabled) return;
    // 로컬 상태에서 제거
    setApkFiles(prev => prev.filter((_, i) => i !== index));

    // 전역 상태에서 제거
    removeUploadState(index);
  };

  // EXE 파일 삭제 핸들러
  const handleRemoveExeFile = (index: number) => {
    if (isDisabled) return;
    // 로컬 상태에서 제거
    setExeFiles(prev => prev.filter((_, i) => i !== index));

    // 전역 상태에서 제거
    removeUploadState(index);
  };

  const closeImageModal = () => {
    setImageModal(false);
  };

  const openImageModal = () => {
    setImageModal(true);
  };

  const handleMissionDescriptionChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (isDisabled) return;
    setDescription(e.target.value);
    setValue("description", e.target.value);
    console.log(`description: ${e.target.value}`);
  };

  const handleCBTDescriptionChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (isDisabled) return;
    setCbtDescription(e.target.value);
    setValue("cbtDescription", e.target.value);
  };

  const clickPlatform = (text: string) => {
    if (isDisabled) return;
    setOpenPlatform(false);
    setPlatform(text);
    setValue("platform", text);
  };

  const clickGenre = (item: any) => {
    if (isDisabled) return;
    // 이미 선택된 장르인지 확인
    const isAlreadySelected = genres.some((genre) => genre.id === item.id);

    if (isAlreadySelected) {
      // 이미 선택된 장르라면 제거
      setGenres(genres.filter((genre) => genre.id !== item.id));
    } else if (genres.length < 3) {
      // 새로운 장르 추가
      const newGenres = [...genres, item];
      setGenres(newGenres);

      // 새로운 장르 배열의 길이가 3이면 모달 닫기
      if (newGenres.length === 3) {
        setOpenGenre(false);
      }
    }
  };

  const ThumbnailImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isDisabled) return;
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      if (selectedFile) {
        const fileSizeInMB = selectedFile.size / (1024 * 1024);
        if (fileSizeInMB < 1) {
          setThumbnailImage(selectedFile);
          setValue("thumbnail", selectedFile);
        } else {
          alert("파일 크기가 1MB를 초과합니다. 다른 파일을 등록해주세요.");
        }
      }
    }
  };

  const removeThumbnailImage = () => {
    if (isDisabled) return;
    setThumbnailImage(undefined);
    setValue("thumbnail", "");
  };

  const backgroundImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isDisabled) return;
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      if (selectedFile) {
        const fileSizeInMB = selectedFile.size / (1024 * 1024);
        if (fileSizeInMB < 1) {
          setBackgroundImage(selectedFile);
          setValue("background", selectedFile);
        } else {
          alert("파일 크기가 1MB를 초과합니다. 다른 파일을 등록해주세요.");
        }
      }
    }
  };

  const removeBackgroundImage = () => {
    if (isDisabled) return;
    setBackgroundImage(undefined);
    setValue("background", "");
  };

  const surveyBackgroundImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isDisabled) return;
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      if (selectedFile) {
        const fileSizeInMB = selectedFile.size / (1024 * 1024);
        if (fileSizeInMB < 1) {
          setSurveyBackgroundImage(selectedFile);
          setValue("surveyBackground", selectedFile);
        } else {
          alert("파일 크기가 1MB를 초과합니다. 다른 파일을 등록해주세요.");
        }
      }
    }
  };

  const removeSurveyBackgroundImage = () => {
    if (isDisabled) return;
    setSurveyBackgroundImage(undefined);
    setValue("surveyBackground", "");
  };

  const ingameImagesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isDisabled) return;
    if (!event.target.files) return;

    const selectedFiles = Array.from(event.target.files);

    // 새 파일 추가 후 전체 파일 목록 계산
    const totalFiles = [...ingameImages, ...selectedFiles];

    // 파일 개수 제한 검사
    if (totalFiles.length > MAX_FILES) {
      alert(`최대 ${MAX_FILES}개의 파일만 업로드할 수 있습니다!`);
      return;
    }

    // 전체 파일 크기 계산
    const totalSize = totalFiles.reduce((acc, file) => acc + file.size, 0);

    if (totalSize > MAX_SIZE) {
      alert("파일들의 총 용량이 5MB를 초과했습니다!");
      return;
    }

    // 파일 목록 업데이트
    setIngameImages(totalFiles);
    setValue("images", totalFiles);
  };

  const removeIngameImages = (index: any) => {
    if (isDisabled) return;
    setIngameImages(ingameImages.filter((_, i) => i !== index));
    setValue("images", ingameImages);
  };

  const phaseOneExampleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isDisabled) return;
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      if (selectedFile) {
        const fileSizeInMB = selectedFile.size / (1024 * 1024);
        if (fileSizeInMB < 1) {
          setPhaseOneExampleImage(selectedFile);
          setValue("phaseOneExample", selectedFile);
        } else {
          alert("파일 크기가 1MB를 초과합니다. 다른 파일을 등록해주세요.");
        }
      }
    }
  };

  // form 값들을 감시하기 위한 watch 설정
  const watchedValues = watch();

  // 상태 추가
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState<string | null>(null);
  const [initialData, setInitialData] = useState<any>(null);
  const [isDataChanged, setIsDataChanged] = useState(false);

  // 초기 데이터 저장을 위한 함수 추가
  const getFormattedData = (): FormattedData => ({
    platform: platform || "",
    gameName: getValues("gameName") || "",
    genres: genres.map(g => g.id), // 장르는 ID만 저장
    description: description || "",
    cbtDescription: cbtDescription || "",
    // 이미지 URL만 비교
    thumbnailImageUrl,
    ingameImageUrls: ingameImageUrls || [],
    backgroundImageUrl,
    surveyBackgroundImageUrl,
    playStoreLink: getValues("playStoreLink") || "",
    appStoreLink: getValues("appStoreLink") || "",
    pcDownloadLink: getValues("pcDownloadLink") || "",
    missionDescription: getValues("missionDescription") || "",
    phaseOneExampleImageUrl,
    reward: rewardValue,
    phaseOneExampleHorizontal: getValues("direction") === "가로형" ? "가로형" : "세로형",
    // 파일 상태 추적을 위한 속성 추가
    hasThumbnailImage: thumbnailImage !== undefined,
    hasBackgroundImage: backgroundImage !== undefined,
    hasSurveyBackgroundImage: surveyBackgroundImage !== undefined,
    hasIngameImages: ingameImages.length > 0,
    hasPhaseOneExampleImage: phaseOneExampleImage !== undefined,
    hasApkFiles: apkFiles.length > 0,
    hasExeFiles: exeFiles.length > 0,
    videoUrl: watch("videoUrl") || initialData?.videoUrl || null,
  });

  // 초기 데이터 저장 수정
  useEffect(() => {
    if (gameProposalProjectInfoDetailsData) {  // !initialData 조건 제거
      console.log(`gameProposalProjectInfoDetailsData.phaseOneExampleHorizontal: ${gameProposalProjectInfoDetailsData.phaseOneExampleHorizontal}`);
      const formattedData = {
        platform: parsingPlatformText(gameProposalProjectInfoDetailsData.platforms),
        gameName: gameProposalProjectInfoDetailsData.title || "",
        genres: gameProposalProjectInfoDetailsData.genres || [],
        description: gameProposalProjectInfoDetailsData.description || "",
        cbtDescription: gameProposalProjectInfoDetailsData.cbtDescription || "",
        thumbnailImageUrl: gameProposalProjectInfoDetailsData.bannerUrl || null,
        ingameImageUrls: gameProposalProjectInfoDetailsData.gameImageUrls || [],
        backgroundImageUrl: gameProposalProjectInfoDetailsData.backgroundUrl || null,
        surveyBackgroundImageUrl: gameProposalProjectInfoDetailsData.surveyBackgroundUrl || null,
        playStoreLink: gameProposalProjectInfoDetailsData.playStoreLink || "",
        appStoreLink: gameProposalProjectInfoDetailsData.appStoreLink || "",
        pcDownloadLink: gameProposalProjectInfoDetailsData.pcDownloadLink || "",
        missionDescription: gameProposalProjectInfoDetailsData.phaseOneDescription || "",
        phaseOneExampleImageUrl: gameProposalProjectInfoDetailsData.phaseOneExampleUrl || null,
        reward: String(gameProposalProjectInfoDetailsData.rewards || "0"),
        phaseOneExampleHorizontal: gameProposalProjectInfoDetailsData.phaseOneExampleHorizontal === false ? "세로형" : "가로형",
        // 초기 상태에서는 파일 없음으로 설정
        hasThumbnailImage: false,
        hasBackgroundImage: false,
        hasSurveyBackgroundImage: false,
        hasIngameImages: false,
        hasPhaseOneExampleImage: false,
        hasApkFiles: false,
        hasExeFiles: false,
        videoUrl: gameProposalProjectInfoDetailsData.youtubeLink || null,
      };
      setInitialData(formattedData);
      setIsDataChanged(false); // 데이터가 새로 로드되면 변경 상태 초기화
    }
  }, [gameProposalProjectInfoDetailsData]);

  // APK 파일 상태를 로드하는 코드를 추가
  useEffect(() => {
    if (gameProposalProjectInfoDetailsData) {
      // 기존 코드 유지...

      // APK/EXE 파일 정보 추가
      if (gameProposalProjectInfoDetailsData.apkGameFile && gameProposalProjectInfoDetailsData.apkGameFile.originalFilename) {
        // APK 파일이 이미 업로드되어 있는 경우 상태 업데이트
        const apkFileInfo = {
          name: gameProposalProjectInfoDetailsData.apkGameFile.originalFilename,
          size: 0, // 실제 크기는 API에서 제공하지 않음
          type: 'application/zip'
        } as File;

        // 기존 파일이 있음을 표시
        setApkFiles([apkFileInfo]);
      }

      if (gameProposalProjectInfoDetailsData.exeGameFile && gameProposalProjectInfoDetailsData.exeGameFile.originalFilename) {
        // EXE 파일이 이미 업로드되어 있는 경우 상태 업데이트
        const exeFileInfo = {
          name: gameProposalProjectInfoDetailsData.exeGameFile.originalFilename,
          size: 0, // 실제 크기는 API에서 제공하지 않음
          type: 'application/zip'
        } as File;

        // 기존 파일이 있음을 표시
        setExeFiles([exeFileInfo]);
      }
    }
  }, [gameProposalProjectInfoDetailsData]);

  // 데이터 변경 감지 로직
  useEffect(() => {
    if (initialData) {
      const currentData = getFormattedData();
      console.log('Initial Data:', initialData);
      console.log('Current Data:', currentData);

      // 이미지 파일 변경 감지 - 기존에 없던 새 속성들이므로 초기 데이터에 추가
      // const initialHasFiles = {
      //   hasThumbnailImage: initialData.hasThumbnailImage || false,
      //   hasBackgroundImage: initialData.hasBackgroundImage || false, 
      //   hasSurveyBackgroundImage: initialData.hasSurveyBackgroundImage || false,
      //   hasIngameImages: initialData.hasIngameImages || false,
      //   hasPhaseOneExampleImage: initialData.hasPhaseOneExampleImage || false,
      //   hasApkFiles: initialData.hasApkFiles || false,
      //   hasExeFiles: initialData.hasExeFiles || false
      // };

      // 파일 상태 변경 확인
      // const filesChanged = 
      //   initialHasFiles.hasThumbnailImage !== currentData.hasThumbnailImage ||
      //   initialHasFiles.hasBackgroundImage !== currentData.hasBackgroundImage ||
      //   initialHasFiles.hasSurveyBackgroundImage !== currentData.hasSurveyBackgroundImage ||
      //   initialHasFiles.hasIngameImages !== currentData.hasIngameImages ||
      //   initialHasFiles.hasPhaseOneExampleImage !== currentData.hasPhaseOneExampleImage ||
      //   initialHasFiles.hasApkFiles !== currentData.hasApkFiles ||
      //   initialHasFiles.hasExeFiles !== currentData.hasExeFiles;

      // console.log('initialHasFiles: ', initialHasFiles);
      // console.log('filesChanged: ', filesChanged);

      // 각 필드별로 비교
      const fieldChanges = Object.keys(initialData).some(key => {
        // 파일 관련 필드는 이미 위에서 확인했으므로 건너뜀
        if (key.startsWith('has')) return false;

        const initialValue = initialData[key];
        const currentValue = currentData[key];

        // 배열인 경우 (genres, ingameImageUrls)
        if (Array.isArray(initialValue) && Array.isArray(currentValue)) {
          // 배열 길이가 다르면 변경된 것으로 간주
          if (initialValue.length !== currentValue.length) return true;

          // 배열 내용 비교 (정렬 후)
          const sortedInitial = [...initialValue].sort();
          const sortedCurrent = [...currentValue].sort();
          return JSON.stringify(sortedInitial) !== JSON.stringify(sortedCurrent);
        }

        // null 체크
        if (initialValue === null && currentValue === null) return false;
        if (initialValue === null || currentValue === null) return true;

        // 문자열로 변환하여 비교
        return String(initialValue).trim() !== String(currentValue).trim();
      });

      // 필드 변경 또는 파일 변경이 있으면 데이터 변경으로 간주
      // const hasChanges = fieldChanges || filesChanged;
      console.log('Field changes:', fieldChanges);
      // console.log('Files changed:', filesChanged);
      // console.log('Has changes:', hasChanges);

      // setIsDataChanged(hasChanges);
      setIsDataChanged(fieldChanges);
    }
  }, [
    platform,
    genres,
    description,
    cbtDescription,
    thumbnailImageUrl,
    ingameImageUrls,
    backgroundImageUrl,
    surveyBackgroundImageUrl,
    phaseOneExampleImageUrl,
    rewardValue,
    selectedDirection,
    thumbnailImage,  // 파일 객체들 추가
    backgroundImage,
    surveyBackgroundImage,
    ingameImages,
    phaseOneExampleImage,
    apkFiles,  // APK, EXE 파일도 추가
    exeFiles,
    watch()
  ]);

  // 네비게이션 핸들러 수정
  const handleNavigation = (path: string) => {
    if (isDataChanged) {
      console.log('데이터 변경 감지됨');
      setShowMoveModal(true);
      setPendingNavigation(path);
    } else {
      console.log('데이터 변경 없음');
      navigate(path);
    }
  };

  // 모달 핸들러
  const handleMoveCancel = () => {
    setShowMoveModal(false);
    setPendingNavigation(null);
  };

  const handleMoveConfirm = () => {
    if (pendingNavigation) {
      handleSave();
      // 저장 후 바로 이동하기 전에 isDataChanged를 false로 설정
      setIsDataChanged(false);
      navigate(pendingNavigation);
    }
    setShowMoveModal(false);
    setPendingNavigation(null);
  };

  const gameProposalProjectInfoApprovedModificationMutation = () => {
    const requestData = {
      description: description,
      cbtDescription: cbtDescription,
      appStoreLink: getValues("appStoreLink") || "",
      playStoreLink: getValues("playStoreLink") || "",
      pcDownloadLink: getValues("pcDownloadLink") || "",
      apkGameFile: gameProposalProjectInfoDetailsData?.apkGameFile ? {
        id: gameProposalProjectInfoDetailsData.apkGameFile.id,
        // visible: apkFilesVisibility[0] || false
      } : null,
      exeGameFile: gameProposalProjectInfoDetailsData?.exeGameFile ? {
        id: gameProposalProjectInfoDetailsData.exeGameFile.id,
        // visible: exeFilesVisibility[0] || false
      } : null
    };

    // LabsGameProposalProjectInfoApprovedModificationMutation.mutate(requestData);

    // 성공 시 초기값 업데이트를 위한 새로운 객체 생성
    const newInitialData = {
      ...initialData,  // 기존 데이터 유지
      // 업데이트된 필드만 덮어쓰기
      description: description,
      cbtDescription: cbtDescription,
      appStoreLink: getValues("appStoreLink") || "",
      playStoreLink: getValues("playStoreLink") || "",
      pcDownloadLink: getValues("pcDownloadLink") || "",
      apkGameFile: gameProposalProjectInfoDetailsData?.apkGameFile ? {
        id: gameProposalProjectInfoDetailsData?.apkGameFile?.id,
        visible: gameProposalProjectInfoDetailsData?.apkGameFile?.visible
      } : null,
      exeGameFile: gameProposalProjectInfoDetailsData?.exeGameFile ? {
        id: gameProposalProjectInfoDetailsData?.exeGameFile?.id,
        visible: gameProposalProjectInfoDetailsData?.exeGameFile?.visible
      } : null
    };
    setInitialData(newInitialData);
    // mutation의 onSuccess에서 setInitialData 호출
    LabsGameProposalProjectInfoApprovedModificationMutation.mutate(requestData, {
      onSuccess: () => {
        setInitialData(newInitialData);
        setIsDataChanged(false);
      }
    });

     // APK 및 EXE 파일 업로드
     apkFiles.forEach((file) => {
      uploadFileToS3(file, gameProposalId || '', 'APK_GAME_FILE', 'GAME_PROPOSAL');
    });

    exeFiles.forEach((file) => {
      uploadFileToS3(file, gameProposalId || '', 'EXE_GAME_FILE', 'GAME_PROPOSAL');
    });
  }


  const basicGameProposalProjectInfoSave = () => {
    
    const formData = new FormData();

    // 게임 정보를 JSON 문자열로 변환
    const gameData = {

      platforms: (() => {
        const platformValue = getValues("platform");
        console.log(`platformValue: ${platformValue}`);
        if (platformValue === "모바일 + PC") return ["MOBILE", "PC"];
        else if (platformValue === "모바일") return ["MOBILE"];
        else if (platformValue === "PC") return ["PC"];
        else return []; // 기본값으로 빈 배열 반환
      })(),
      title: getValues("gameName"),
      genres: genres.map(genre => genre.id),
      description: description,
      cbtDescription: cbtDescription,
      youtubeLink: getValues("videoUrl"),

      pcDownloadLink: (() => {
        const platformValue = getValues("platform");
        if (platformValue === "모바일 + PC" || platformValue === "PC") {
          return getValues("pcDownloadLink") || "";
        }
        return "";
      })(),
      playStoreLink: (() => {
        const platformValue = getValues("platform");
        if (platformValue === "모바일 + PC" || platformValue === "모바일") {
          return getValues("playStoreLink") || "";
        }
        return "";
      })(),

      appStoreLink: (() => {
        const platformValue = getValues("platform");
        if (platformValue === "모바일 + PC" || platformValue === "모바일") {
          return getValues("appStoreLink") || "";
        }
        return "";
      })(),

      downloadType: getValues("downloadType"),
      phaseOneDescription: getValues("missionDescription"),
      phaseOneExampleHorizontal: getValues("direction") === '가로형',
      rewards: getValues("reward") === null ? 0 : getValues("reward"),
    };

    console.log(`gameData.platforms: ${gameData.platforms}`);
    // 게임 정보를 Blob으로 변환하여 추가
    const gameDataBlob = new Blob([JSON.stringify(gameData)], { type: 'application/json' });
    formData.append("data", gameDataBlob);

    // 이미지 파일들 추가
    if (thumbnailImage instanceof File) {
      formData.append("thumbnail", thumbnailImage);
    }
    if (backgroundImage instanceof File) {
      formData.append("background", backgroundImage);
    }
    if (phaseOneExampleImage instanceof File) {
      formData.append("phaseOneExample", phaseOneExampleImage);
    }
    if (surveyBackgroundImage instanceof File) {
      formData.append("surveyBackground", surveyBackgroundImage);
    }
    if (ingameImages.length > 0) {
      ingameImages.forEach((image) => {
        if (image instanceof File) {
          formData.append("images", image);
        }
      });
    }

    gameProposalProjectInfoSaveMutation.mutate(formData);
  };

  const handleSave = () => {
    console.log(`rewards: ${getValues("reward")}`);

    // projectInfoSavable이 false면 함수 실행을 중단
    if (!gameProposalStepAvailabilityData?.projectInfoSavable) {
      return;
    }

    if (isNotChangeable) {
      gameProposalProjectInfoApprovedModificationMutation();
      return;
    }

      basicGameProposalProjectInfoSave();   
       // const formData = new FormData();

    // // 게임 정보를 JSON 문자열로 변환
    // const gameData = {

    //   platforms: (() => {
    //     const platformValue = getValues("platform");
    //     console.log(`platformValue: ${platformValue}`);
    //     if (platformValue === "모바일 + PC") return ["MOBILE", "PC"];
    //     else if (platformValue === "모바일") return ["MOBILE"];
    //     else if (platformValue === "PC") return ["PC"];
    //     else return []; // 기본값으로 빈 배열 반환
    //   })(),
    //   title: getValues("gameName"),
    //   genres: genres.map(genre => genre.id),
    //   description: description,
    //   cbtDescription: cbtDescription,
    //   youtubeLink: getValues("videoUrl"),

    //   pcDownloadLink: (() => {
    //     const platformValue = getValues("platform");
    //     if (platformValue === "모바일 + PC" || platformValue === "PC") {
    //       return getValues("pcDownloadLink") || "";
    //     }
    //     return "";
    //   })(),
    //   playStoreLink: (() => {
    //     const platformValue = getValues("platform");
    //     if (platformValue === "모바일 + PC" || platformValue === "모바일") {
    //       return getValues("playStoreLink") || "";
    //     }
    //     return "";
    //   })(),

    //   appStoreLink: (() => {
    //     const platformValue = getValues("platform");
    //     if (platformValue === "모바일 + PC" || platformValue === "모바일") {
    //       return getValues("appStoreLink") || "";
    //     }
    //     return "";
    //   })(),

    //   downloadType: getValues("downloadType"),
    //   phaseOneDescription: getValues("missionDescription"),
    //   phaseOneExampleHorizontal: getValues("direction") === '가로형',
    //   rewards: getValues("reward") === null ? 0 : getValues("reward"),
    // };

    // console.log(`gameData.platforms: ${gameData.platforms}`);
    // // 게임 정보를 Blob으로 변환하여 추가
    // const gameDataBlob = new Blob([JSON.stringify(gameData)], { type: 'application/json' });
    // formData.append("data", gameDataBlob);

    // // 이미지 파일들 추가
    // if (thumbnailImage instanceof File) {
    //   formData.append("thumbnail", thumbnailImage);
    // }
    // if (backgroundImage instanceof File) {
    //   formData.append("background", backgroundImage);
    // }
    // if (phaseOneExampleImage instanceof File) {
    //   formData.append("phaseOneExample", phaseOneExampleImage);
    // }
    // if (surveyBackgroundImage instanceof File) {
    //   formData.append("surveyBackground", surveyBackgroundImage);
    // }
    // if (ingameImages.length > 0) {
    //   ingameImages.forEach((image) => {
    //     if (image instanceof File) {
    //       formData.append("images", image);
    //     }
    //   });
    // }

    // gameProposalProjectInfoSaveMutation.mutate(formData);
  };


  const gameProposalProjectInfoSaveMutation = useMutation({
    mutationFn: (data: FormData) => GameProposalProjectInfoSaveApi(Number(gameProposalId), data),
    onSuccess: (response) => {
      if (response.status === 200) {
        setShowSuccessModal(true);
        console.log("저장 성공");

        queryClient.invalidateQueries({
          queryKey: ["gameProposalStepAvailability", gameProposalId]
        });

        queryClient.refetchQueries({
          queryKey: ["gameProposalStepAvailability", gameProposalId]
        });

        // 추가 코드: gameProposalProjectInfoDetails 쿼리 무효화 및 재요청
        queryClient.invalidateQueries({
          queryKey: ["gameProposalProjectInfoDetails", gameProposalId]
        });

        queryClient.refetchQueries({
          queryKey: ["gameProposalProjectInfoDetails", gameProposalId]
        });

        // 저장 후 현재 데이터를 새로운 초기 데이터로 설정
        const currentData = getFormattedData();
        setInitialData(currentData);
        setIsDataChanged(false);

        // APK 및 EXE 파일 업로드
        apkFiles.forEach((file) => {
          uploadFileToS3(file, gameProposalId || '', 'APK_GAME_FILE', 'GAME_PROPOSAL');
        });

        exeFiles.forEach((file) => {
          uploadFileToS3(file, gameProposalId || '', 'EXE_GAME_FILE', 'GAME_PROPOSAL');
        });
      }
    },
    onError: (error) => {
      console.log("저장 실패");
    },
  });

  const LabsGameProposalProjectInfoApprovedModificationMutation = useMutation({
    mutationFn: (data: any) => LabsGameProposalProjectInfoApprovedModificationAPI(Number(gameProposalId), data),
    onSuccess: (response) => {
      if (response.status === 200) {
        setShowSuccessModal(true);
        console.log("저장 성공");

        // 쿼리 무효화 및 재요청
        queryClient.invalidateQueries({
          queryKey: ["gameProposalProjectInfoDetails", gameProposalId]
        });

        queryClient.refetchQueries({
          queryKey: ["gameProposalProjectInfoDetails", gameProposalId]
        });

        // 저장 후 현재 데이터를 새로운 초기 데이터로 설정
        // setInitialData(requestData);
        setIsDataChanged(false);
        // window.location.reload();
      }
    },
    onError: (error) => {
      console.log("저장 실패");
    },
  });


  // 데이터가 로드되면 상태 업데이트
  useEffect(() => {
    if (gameProposalProjectInfoDetailsData) {

      setPlatform(parsingPlatformText(gameProposalProjectInfoDetailsData.platforms));
      setValue("platform", parsingPlatformText(gameProposalProjectInfoDetailsData.platforms));
      // setPlatform
      setGenres(parsingGenreText(gameProposalProjectInfoDetailsData.genres));

      // 기타 필요한 상태 업데이트
      setValue("gameName", gameProposalProjectInfoDetailsData.title);
      setDescription(gameProposalProjectInfoDetailsData.description || "");
      setCbtDescription(gameProposalProjectInfoDetailsData.cbtDescription || "");
      // 등등...

      // URL 설정
      setThumbnailImageUrl(gameProposalProjectInfoDetailsData.bannerUrl || null);
      setBackgroundImageUrl(gameProposalProjectInfoDetailsData.backgroundUrl || null);
      setSurveyBackgroundImageUrl(gameProposalProjectInfoDetailsData.surveyBackgroundUrl || null);
      setIngameImageUrls(gameProposalProjectInfoDetailsData.gameImageUrls || []);

      // setValue("videoUrl", gameProposalProjectInfoDetailsData.videoUrl || "");
      setValue("videoLink", gameProposalProjectInfoDetailsData.youtubeLink || "");
      setValue("playStoreLink", gameProposalProjectInfoDetailsData.playStoreLink || "");
      setValue("appStoreLink", gameProposalProjectInfoDetailsData.appStoreLink || "");
      setValue("pcDownloadLink", gameProposalProjectInfoDetailsData.pcDownloadLink || "");
      setValue("downloadType", gameProposalProjectInfoDetailsData.downloadType || "");

      setValue("missionDescription", gameProposalProjectInfoDetailsData.phaseOneDescription || "");
      setValue("direction", gameProposalProjectInfoDetailsData.phaseOneExampleHorizontal ? "가로형" : "세로형");
      setPhaseOneExampleImageUrl(gameProposalProjectInfoDetailsData.phaseOneExampleUrl || null);


      // rewardValue 
      setValue("reward", gameProposalProjectInfoDetailsData.rewards || "1000");
      const rewardAmount = gameProposalProjectInfoDetailsData.rewards || "1000";
      setValue("reward", rewardAmount);
      setRewardValue(rewardAmount.toString()); // rewardValue 상태도 함께 업데이트

    }
  }, [gameProposalProjectInfoDetailsData]);

  const handleRewardChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isDisabled) return;
    // 숫자만 입력 가능하도록 정규식 체크
    const value = e.target.value;
    const numericValue = value.replace(/[^0-9]/g, '');

    let newValue = numericValue;

    // 입력값이 있을 때 0으로 시작하면 0 제거
    if (numericValue === "0" && value !== "0") {
      newValue = "";
    } else if (numericValue.startsWith("0") && numericValue.length > 1) {
      // 0으로 시작하고 길이가 1보다 크면 앞의 0 제거
      newValue = numericValue.substring(1);
    }

    // 두 상태 모두 업데이트
    setRewardValue(newValue);
    setValue("reward", newValue);

    // 변경 여부를 즉시 감지하기 위해 데이터 비교 강제
    if (initialData) {
      const currentData = getFormattedData();
      const hasChanges = initialData.reward !== newValue;
      setIsDataChanged(prevIsDataChanged => hasChanges || prevIsDataChanged);
    }
  };

  // gameProposalStepAvailabilityData 쿼리 (바로 사용할 수 있게 위쪽으로 이동)
  const { data: gameProposalStepAvailabilityData } = useQuery<GameProposalStepAvailabilityResponse>({
    queryKey: ["gameProposalStepAvailability", gameProposalId],
    queryFn: async () => {
      const response = await GameProposalStepAvailabilityAPI(Number(gameProposalId));
      return response.data;
    },
    enabled: true
  });

  // isDisabled 상태 추가 - gameProposalStepAvailabilityData 이후에 선언
  const isDisabled = gameProposalStepAvailabilityData?.projectInfoSavable === false;

  const isNotChangeable = gameProposalStepAvailabilityData?.status === 'APPROVED';

  console.log('************isNotChangeable: ', isNotChangeable);
  // Update the state based on the API data
  useEffect(() => {
    if (gameProposalProjectInfoDetailsData) {
      setSelectedDirection(gameProposalProjectInfoDetailsData.phaseOneExampleHorizontal ? "가로형" : "세로형");
    }
  }, [gameProposalProjectInfoDetailsData]);

  return (
    <>
      <Main>
        {imageModal && (
          <ImageModal
            close={closeImageModal}
            ThumbnailImageChange={ThumbnailImageChange}
            thumbnailImage={thumbnailImage}
            setThumbnailImage={setThumbnailImage}
            removeThumbnailImage={removeThumbnailImage}
            backgroundImageChange={backgroundImageChange}
            backgroundImage={backgroundImage}
            setBackgroundImage={setBackgroundImage}
            removeBackgroundImage={removeBackgroundImage}
            surveyBackgroundImageChange={surveyBackgroundImageChange}
            surveyBackgroundImage={surveyBackgroundImage}
            setsurveyBackgroundImage={setSurveyBackgroundImage}
            removeSurveyBackgroundImage={removeSurveyBackgroundImage}
            ingameImagesChange={ingameImagesChange}
            ingameImages={ingameImages}
            setIngameImages={setIngameImages}
            removeIngameImages={removeIngameImages}
            thumbnailImageUrl={thumbnailImageUrl}
            backgroundImageUrl={backgroundImageUrl}
            surveyBackgroundImageUrl={surveyBackgroundImageUrl}
            ingameImageUrls={ingameImageUrls}
            isDisabled={isDisabled}
          />
        )}
        <TopWrapper>
          <TopContainer>
            <Link to={`/home/test/draft/${gameProposalId}`} style={{ textDecoration: "none" }}>
              <TopTitle>
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  style={{ marginRight: "20px" }}
                />
                2단계 프로젝트 정보
              </TopTitle>
            </Link>
            <BtnContainer>
              <SaveBtn
                isActive={gameProposalStepAvailabilityData?.projectInfoSavable || false}
                onClick={gameProposalStepAvailabilityData?.projectInfoSavable ? handleSave : undefined}
              >
                저장하기
              </SaveBtn>
            </BtnContainer>
          </TopContainer>
          <NavCotainer>
            <CustomNavLink
              to={`/home/test-list/${gameProposalId}/add/first`}
              status={gameProposalStepAvailabilityData?.testPlanAvailable || false}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation(`/home/test-list/${gameProposalId}/add/first`);
              }}
            >
              1. 테스트 플랜
            </CustomNavLink>
            <CustomNavLink
              to={`/home/test-list/${gameProposalId}/add/second`}
              status={gameProposalStepAvailabilityData?.projectInfoAvailable || false}
              isActive={true}
            >
              2. 프로젝트 정보
            </CustomNavLink>
            <CustomNavLink
              to={`/home/test-list/${gameProposalId}/add/third`}
              status={gameProposalStepAvailabilityData?.questionCompositionAvailable || false}
              onClick={(e) => {
                e.preventDefault();
                handleNavigation(`/home/test-list/${gameProposalId}/add/third`);
              }}
            >
              3. 질문 구성
            </CustomNavLink>
            <TooltipContainer>
            <CustomNavLink
              to={`/home/test-list/${gameProposalId}/add/forth`}
              status={gameProposalStepAvailabilityData?.estimateAvailable}
            >
              4. 견적 확인
            </CustomNavLink>
            <Tooltip disabled={!gameProposalStepAvailabilityData?.estimateAvailable}>
              이전 단계의 필수값을 모두 입력해 주세요
            </Tooltip>
            </TooltipContainer>
          </NavCotainer>
        </TopWrapper>
        <ContentWrapper>
          <Title>게임 기본 설명 <span style={{ color: '#2282e9' }}> *</span></Title>
          <Comment>
            유저들이 게임을 잘 이해할 수 있도록 명확하게 소개해주세요.
          </Comment>
          <SelectContainer>
            <SelectBox
              onClick={() => (!isDisabled || !isNotChangeable) && setOpenPlatform((prev) => !prev)}
              style={{
                borderColor: isDisabled || isNotChangeable ? '#CCCCCC' : '#2282E9',
                cursor: isDisabled || isNotChangeable ? 'not-allowed' : 'pointer',
                opacity: isDisabled || isNotChangeable ? 0.7 : 1
              }}
            >
              {platform === "게임의 플랫폼을 선택해 주세요." ? (
                <SelectText>{platform}</SelectText>
              ) : (
                <SelectText style={{ color: isDisabled || isNotChangeable ? "#CCCCCC" : "#2282e9" }}>{platform}</SelectText>
              )}

              <FontAwesomeIcon
                icon={faPlay}
                style={{
                  position: "absolute",
                  right: "40px",
                  top: "28px",
                  rotate: "90deg",
                  color: isDisabled ? "#CCCCCC" : "#8e8e8e",
                }}
              />
            </SelectBox>
            {openPlatform && !isDisabled && !isNotChangeable && (
              <PlatformContainer>
                <Platform onClick={() => clickPlatform("모바일")}>
                  모바일
                </Platform>
                <Platform onClick={() => clickPlatform("PC")}>PC</Platform>
                <Platform onClick={() => clickPlatform("모바일 + PC")}>
                  모바일 + PC
                </Platform>
              </PlatformContainer>
            )}
          </SelectContainer>
          {
            gameProposalProjectInfoDetailsData?.rejections?.reasons?.platforms !== '' && (
              <>
                <div style={{ marginBottom: '-16px' }} />
                <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                  {gameProposalProjectInfoDetailsData?.rejections?.reasons?.platforms}
                </span>
                <div style={{ marginBottom: '16px' }} />
              </>
            )
          }


          <div style={{ display: "flex", flexDirection: "column" }}>
            <Input
              type="text"
              placeholder="게임 이름을 작성해주세요."
              {...register("gameName")}
              disabled={isDisabled || isNotChangeable}
              style={{
                borderColor: isDisabled || isNotChangeable ? '#CCCCCC' : '#2282E9',
                color: isDisabled || isNotChangeable ? '#CCCCCC' : '#2282E9',
                backgroundColor: isDisabled || isNotChangeable ? '#F5F5F5' : 'white',
                cursor: isDisabled || isNotChangeable ? 'not-allowed' : 'text',
                marginBottom: "0px"
              }}
            />
            {
              gameProposalProjectInfoDetailsData?.rejections?.reasons?.title !== '' && (
                <>
                  <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                    * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.title}
                  </span>

                </>
              )
            }
            <div style={{ marginBottom: '16px' }} />
          </div>

          <SelectContainer>
            <SelectBox
              onClick={() => {
                if (isDisabled || isNotChangeable) return;

                setOpenGenre((prev) => !prev);
              }}
              style={{
                borderColor: isDisabled || isNotChangeable ? '#CCCCCC' : '#2282E9',
                cursor: isDisabled || isNotChangeable ? 'not-allowed' : 'pointer',
                opacity: isDisabled || isNotChangeable ? 0.7 : 1
              }}
            >
              {genres.length === 0 ? (
                <SelectText>
                  게임 장르를 선택해주세요. 최대 3개까지 선택 가능합니다.
                </SelectText>
              ) : (
                <GenreBadgeContainer>
                  {genres.map((item) => (
                    <GenreBadge
                      key={item.id}
                      onClick={(e) => {
                        if (isDisabled || isNotChangeable) return;
                        e.stopPropagation();
                        setGenres(genres.filter(genre => genre.id !== item.id));
                      }}
                      style={{
                        backgroundColor: isDisabled || isNotChangeable ? '#8E8E8E' : '#2282e9',
                        cursor: isDisabled || isNotChangeable ? 'not-allowed' : 'pointer',
                      }}
                    >
                      {item.content}
                    </GenreBadge>
                  ))}
                </GenreBadgeContainer>
              )}

              <FontAwesomeIcon
                icon={faPlay}
                style={{
                  position: "absolute",
                  right: "40px",
                  top: "28px",
                  rotate: "90deg",
                  color: isDisabled ? "#CCCCCC" : "#8e8e8e",
                }}
              />
            </SelectBox>
            {openGenre && !isDisabled && (
              <GenreContainer>
                {genre.map((item) => (
                  <Genre
                    key={item.id}
                    isSelected={genres.some(genre => genre.id === item.id)}
                    onClick={() => clickGenre(item)}
                  >
                    {item.content}
                  </Genre>
                ))}
                <Genre></Genre>
                <Genre></Genre>
              </GenreContainer>
            )}
          </SelectContainer>

          {
            gameProposalProjectInfoDetailsData?.rejections?.reasons?.genres !== '' && (
              <>
                <div style={{ marginBottom: '-16px' }} />
                <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                  * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.genres}
                </span>
                <div style={{ marginBottom: '16px' }} />
              </>
            )
          }


          <TextAreaContainer>
            <TextArea
              placeholder="게임 설명 및 플레이 방식을 작성해주세요."
              maxLength={2000}
              {...register("description", {
                onChange: handleMissionDescriptionChange,
              })}
              value={description}
              disabled={isDisabled}
              style={{
                borderColor: isDisabled ? '#CCCCCC' : '#2282E9',
                color: isDisabled ? '#CCCCCC' : '#2282E9',
                backgroundColor: isDisabled ? '#F5F5F5' : 'white',
                cursor: isDisabled ? 'not-allowed' : 'text',
                // fontWeight: 500
              }}
            />
            <Count>
              <span style={{ color: isDisabled ? "#CCCCCC" : "#2282e9", marginRight: "5px" }}>
                {description.length}
              </span>{" "}
              / 2000
            </Count>
          </TextAreaContainer>
          {
            gameProposalProjectInfoDetailsData?.rejections?.reasons?.description !== '' && (
              <>
                <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                  * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.description}
                </span>
                {/* <div style={{ marginBottom: '16px' }} /> */}
              </>
            )
          }
          <Bar />
          <Title>CBT 정보 <span style={{ color: '#2282e9' }}> *</span></Title>
          <Comment>CBT 참여 방법 및 유의사항을 설명해주세요.</Comment>
          <TextAreaContainer style={{ marginBottom: "30px" }}>
            <TextArea
              maxLength={800}
              placeholder="CBT 신청하기를 클릭하면 팝업창에 표시되는 텍스트 입니다. "
              {...register("cbtDescription", {
                onChange: handleCBTDescriptionChange,
              })}
              value={cbtDescription}
              disabled={isDisabled}
              style={{
                borderColor: isDisabled ? '#CCCCCC' : '#2282E9',
                color: isDisabled ? '#CCCCCC' : '#2282E9',
                backgroundColor: isDisabled ? '#F5F5F5' : 'white',
                cursor: isDisabled ? 'not-allowed' : 'text'
              }}
            />
            <Count>
              <span style={{ color: isDisabled ? "#CCCCCC" : "#2282e9", marginRight: "5px" }}>
                {cbtDescription.length}
              </span>{" "}
              / 800
            </Count>
            {
              gameProposalProjectInfoDetailsData?.rejections?.reasons?.cbtDescription !== '' && (
                <>
                  <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                    * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.cbtDescription}
                    {/* CBT 반려 사유 */}
                  </span>
                  <div style={{ marginBottom: '16px' }} />
                </>
              )
            }
          </TextAreaContainer>

          <GuideBox>
            <div>
              <GuideTitle>💡 GUIDE</GuideTitle>
              <GuideDesc>
                CBT 신청하기 팝업창에 <br />
                표시되는 텍스트 입니다.
              </GuideDesc>
            </div>
            <img src={GuideImg1} alt="img" />
          </GuideBox>
          <Bar />
          <Title>게임 이미지 <span style={{ color: '#2282e9' }}> *</span> </Title>
          <Comment>영상 및 이미지를 규격에 맞게 추가해주세요.</Comment>
          {(thumbnailImage || thumbnailImageUrl ||
            ingameImages.length !== 0 || ingameImageUrls.length !== 0 ||
            backgroundImage || backgroundImageUrl ||
            surveyBackgroundImage || surveyBackgroundImageUrl) ? (
            <AddImg
              onClick={isDisabled || isNotChangeable ? undefined : openImageModal}
              style={{
                alignItems: "stretch",
                borderColor: isDisabled || isNotChangeable ? '#CCCCCC' : '#2282E9',
                cursor: isDisabled || isNotChangeable ? 'not-allowed' : 'pointer',
                opacity: isDisabled || isNotChangeable ? 0.7 : 1
              }}
            >
              <ImagesWrapper>
                {((thumbnailImage || thumbnailImageUrl) &&
                  (ingameImages.length !== 0 || ingameImageUrls?.length !== 0) &&
                  (backgroundImage || backgroundImageUrl) &&
                  (surveyBackgroundImage || surveyBackgroundImageUrl)) && (
                    <div
                      style={{
                        backgroundColor: "#2282e9",
                        width: "20px",
                        height: "20px",
                        borderRadius: "999px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginLeft: "18px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faCheck}
                        style={{
                          color: "white",
                        }}
                      />
                    </div>
                  )}
                <ImagesContainer>
                  {thumbnailImage ? (
                    <ThumbnailImg
                      src={URL.createObjectURL(thumbnailImage)}
                      alt=""
                    />
                  ) : thumbnailImageUrl ? (
                    <ThumbnailImg
                      src={thumbnailImageUrl}
                      alt=""
                    />
                  ) : null}

                  {ingameImages.map((img, index) => (
                    <PreviewIngameImg
                      key={`local-${index}`}
                      src={URL.createObjectURL(img)}
                      alt={`인게임 이미지 ${index + 1}`}
                    />
                  ))}

                  {ingameImageUrls?.map((url, index) => (
                    <PreviewIngameImg
                      key={`url-${index}`}
                      src={url}
                      alt={`인게임 이미지 ${index + 1}`}
                    />
                  ))}

                  {backgroundImage ? (
                    <BackgroundImg
                      src={URL.createObjectURL(backgroundImage)}
                      alt=""
                    />
                  ) : backgroundImageUrl ? (
                    <BackgroundImg
                      src={backgroundImageUrl}
                      alt=""
                    />
                  ) : null}

                  {surveyBackgroundImage ? (
                    <BackgroundImg
                      src={URL.createObjectURL(surveyBackgroundImage)}
                      alt=""
                    />
                  ) : surveyBackgroundImageUrl ? (
                    <BackgroundImg
                      src={surveyBackgroundImageUrl}
                      alt=""
                    />
                  ) : null}
                </ImagesContainer>
                {isDisabled || isNotChangeable ? null : <ImgChangeBtn onClick={openImageModal}>
                  + 게임 이미지 변경하기
                </ImgChangeBtn>}
              </ImagesWrapper>
            </AddImg>
          ) : (
            <AddImg
              onClick={isDisabled || isNotChangeable ? undefined : openImageModal}
              style={{
                borderColor: isDisabled || isNotChangeable ? '#CCCCCC' : '#2282E9',
                color: isDisabled || isNotChangeable ? '#CCCCCC' : '#2282E9',
                cursor: isDisabled || isNotChangeable ? 'not-allowed' : 'pointer',
                opacity: isDisabled || isNotChangeable ? 0.7 : 1
              }}
            >
              <Plus style={{ color: isDisabled || isNotChangeable ? '#CCCCCC' : '#2282E9' }}>+</Plus>
              게임 이미지 추가하기
            </AddImg>
          )}

          {
            gameProposalProjectInfoDetailsData?.rejections?.reasons?.images !== '' &&
            <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
              * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.images}
              {/* 반려 사유 */}
            </span>
          }
          {/* 간격 조절 */}
          <div style={{ marginBottom: '40px' }} />
          <Title>게임 영상</Title>
          <Comment>
            유튜브 페이지 상단 주소창 URL 을 복사한 링크를 작성해주세요.
          </Comment>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Input
              style={{
                borderColor: isDisabled || isNotChangeable ? '#CCCCCC' : '#ededed',
                // marginBottom: "70px",
                marginBottom: "1px",
                color: isDisabled || isNotChangeable ? '#CCCCCC' : '#2282E9',
                backgroundColor: isDisabled || isNotChangeable ? '#F5F5F5' : 'white',
                cursor: isDisabled || isNotChangeable ? 'not-allowed' : 'text'
              }}
              defaultValue={initialData?.videoUrl}
              {...register("videoUrl")}
              disabled={isDisabled || isNotChangeable}
            />
            {
              gameProposalProjectInfoDetailsData?.rejections?.reasons?.youtubeLink !== '' && (
                <>
                  <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                    * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.youtubeLink}
                    {/* 게임 영상 반려 사유 */}
                  </span>

                </>
              )
            }
          </div>
          {/* <div style={{ marginBottom: '16px' }} /> */}
          <Bar />
          <Title>게임 다운로드 방식</Title>
          <Comment>
            원하는 형태의 다운로드 방식을 선택해주세요. 중복으로 작성이
            가능합니다.
          </Comment>
          <div style={{ marginBottom: '16px' }} />
          <SubTitle>링크 형태<span style={{ color: '#2282e9' }}> *</span></SubTitle>
          {(platform !== "모바일" && platform !== "PC" && platform !== "모바일 + PC") ? (
            <>
              <DisabledContainer>
                <LinkLabel>PC 다운로드 링크</LinkLabel>
                <LinkBar />
                <DisabledInput disabled />
              </DisabledContainer>
              <DisabledContainer>
                <LinkLabel>안드로이드 다운로드 링크</LinkLabel>
                <LinkBar />
                <DisabledInput disabled />
              </DisabledContainer>
              <DisabledContainer>
                <LinkLabel>IOS 다운로드 링크</LinkLabel>
                <LinkBar />
                <DisabledInput disabled />
              </DisabledContainer>
            </>
          ) : platform === "모바일" ? (
            <>
              <DisabledContainer>
                <LinkLabel>PC 다운로드 링크</LinkLabel>
                <LinkBar />
                <DisabledInput disabled />
              </DisabledContainer>
              <LinkInputContainer>
                <LinkLabel>안드로이드 다운로드 링크</LinkLabel>
                <LinkBar />
                <LinkInput
                  {...register('playStoreLink')}
                  disabled={!gameProposalStepAvailabilityData?.projectInfoSavable}
                  style={{
                    color: !gameProposalStepAvailabilityData?.projectInfoSavable ? '#8E8E8E' : '#2282E9',
                    cursor: !gameProposalStepAvailabilityData?.projectInfoSavable ? 'not-allowed' : 'text'
                  }}
                />
              </LinkInputContainer>
              {
                gameProposalProjectInfoDetailsData?.rejections?.reasons?.pcDownloadLink !== '' &&
                (
                  <>
                    <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                      * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.pcDownloadLink}
                      {/* 반려 사유 */}
                    </span>

                  </>
                )
              }
              <div style={{ marginBottom: '16px' }} />
              <LinkInputContainer>
                <LinkLabel>IOS 다운로드 링크</LinkLabel>
                <LinkBar></LinkBar>
                <LinkInput
                  {...register('appStoreLink')}
                  disabled={!gameProposalStepAvailabilityData?.projectInfoSavable}
                  style={{
                    color: !gameProposalStepAvailabilityData?.projectInfoSavable ? '#8E8E8E' : '#2282E9',
                    cursor: !gameProposalStepAvailabilityData?.projectInfoSavable ? 'not-allowed' : 'text'
                  }}
                />
              </LinkInputContainer>
              {
                gameProposalProjectInfoDetailsData?.rejections?.reasons?.appStoreLink !== '' &&
                (
                  <>
                    <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                      * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.appStoreLink}
                      {/* 반려 사유 */}
                    </span>
                    <div style={{ marginBottom: '16px' }} />
                  </>
                )
              }
            </>
          ) : platform === "PC" ? (
            <>
              <LinkInputContainer>
                <LinkLabel>PC 다운로드 링크</LinkLabel>
                <LinkBar />
                <LinkInput
                  {...register('pcDownloadLink')}
                  disabled={!gameProposalStepAvailabilityData?.projectInfoSavable}
                  style={{
                    color: !gameProposalStepAvailabilityData?.projectInfoSavable ? '#8E8E8E' : '#2282E9',
                    cursor: !gameProposalStepAvailabilityData?.projectInfoSavable ? 'not-allowed' : 'text'
                  }}
                />
              </LinkInputContainer>

              {
                gameProposalProjectInfoDetailsData?.rejections?.reasons?.pcDownloadLink !== '' &&
                (
                  <>
                    <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                      * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.pcDownloadLink}
                      {/* 반려 사유 */}
                    </span>

                  </>
                )
              }
              <div style={{ marginBottom: '16px' }} />
              <DisabledContainer>
                <LinkLabel>안드로이드 다운로드 링크</LinkLabel>
                <LinkBar></LinkBar>
                <DisabledInput disabled />
              </DisabledContainer>
              <DisabledContainer>
                <LinkLabel>IOS 다운로드 링크</LinkLabel>
                <LinkBar></LinkBar>
                <DisabledInput disabled />
              </DisabledContainer>
            </>
          ) : platform === "모바일 + PC" ? (
            <>
              <LinkInputContainer>
                <LinkLabel>PC 다운로드 링크</LinkLabel>
                <LinkBar></LinkBar>
                <LinkInput
                  {...register('pcDownloadLink')}
                  disabled={!gameProposalStepAvailabilityData?.projectInfoSavable}
                  style={{
                    color: !gameProposalStepAvailabilityData?.projectInfoSavable ? '#8E8E8E' : '#2282E9',
                    cursor: !gameProposalStepAvailabilityData?.projectInfoSavable ? 'not-allowed' : 'text'
                  }}
                />
              </LinkInputContainer>
              {
                gameProposalProjectInfoDetailsData?.rejections?.reasons?.pcDownloadLink !== '' &&
                (
                  <>
                    <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                      * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.pcDownloadLink}
                      {/* 반려 사유 */}
                    </span>

                  </>
                )
              }
              <div style={{ marginBottom: '16px' }} />
              <LinkInputContainer>
                <LinkLabel>안드로이드 다운로드 링크</LinkLabel>
                <LinkBar></LinkBar>
                <LinkInput
                  {...register('playStoreLink')}
                  disabled={!gameProposalStepAvailabilityData?.projectInfoSavable}
                  style={{
                    color: !gameProposalStepAvailabilityData?.projectInfoSavable ? '#8E8E8E' : '#2282E9',
                    cursor: !gameProposalStepAvailabilityData?.projectInfoSavable ? 'not-allowed' : 'text'
                  }}
                />
              </LinkInputContainer>
              {
                gameProposalProjectInfoDetailsData?.rejections?.reasons?.playStoreLink !== '' &&
                (
                  <>
                    <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                      * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.playStoreLink}
                      {/* 반려 사유 */}
                    </span>

                  </>
                )
              }
              <div style={{ marginBottom: '16px' }} />
              <LinkInputContainer>
                <LinkLabel>IOS 다운로드 링크</LinkLabel>
                <LinkBar></LinkBar>
                <LinkInput
                  {...register('appStoreLink')}
                  disabled={!gameProposalStepAvailabilityData?.projectInfoSavable}
                  style={{
                    color: !gameProposalStepAvailabilityData?.projectInfoSavable ? '#8E8E8E' : '#2282E9',
                    cursor: !gameProposalStepAvailabilityData?.projectInfoSavable ? 'not-allowed' : 'text'
                  }}
                />
              </LinkInputContainer>
              {
                gameProposalProjectInfoDetailsData?.rejections?.reasons?.appStoreLink !== '' &&
                (
                  <>
                    <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                      * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.appStoreLink}
                      {/* 반려 사유 */}
                    </span>
                    <div style={{ marginBottom: '16px' }} />
                  </>
                )
              }
            </>
          ) : ""}


          <br />
          {(platform !== "모바일" && platform !== "PC" && platform !== "모바일 + PC") ? (
            <>
              <SubTitle style={{ color: '#c0c0c0' }}>APK 파일 다운로드 형태 (모바일)</SubTitle>
              <DisabledAddImg>
                <DisabledPlus>+</DisabledPlus>APK 게임 파일 업로드
              </DisabledAddImg>
              <SubTitle style={{ color: '#c0c0c0' }}>exe 파일 다운로드 형태 (PC)</SubTitle>
              <DisabledAddImg>
                <DisabledPlus>+</DisabledPlus>exe 게임 파일 업로드
              </DisabledAddImg>
            </>
          ) : platform === "모바일" ? (
            <>
              <SubTitle style={{ color: 'black' }}>APK 파일 다운로드 형태 (모바일)</SubTitle>
              <AddImg onClick={!gameProposalStepAvailabilityData?.projectInfoSavable ? undefined : handleApkFileSelect}
                style={{
                  cursor: !gameProposalStepAvailabilityData?.projectInfoSavable ? 'not-allowed' : 'pointer',
                  borderColor: !gameProposalStepAvailabilityData?.projectInfoSavable ? '#CCCCCC' : '#2282E9',
                  color: !gameProposalStepAvailabilityData?.projectInfoSavable ? '#CCCCCC' : '#2282E9',
                  opacity: !gameProposalStepAvailabilityData?.projectInfoSavable ? 0.7 : 1
                }}
              >

                {apkFiles.length === 0 && (
                  <>
                    <Plus>+</Plus>
                    <span style={{ color: '#2282e9', fontWeight: 600 }}>APK 게임 파일 업로드</span>
                  </>
                )}
                {apkFiles.length > 0 && (
                  <FileList>
                    {apkFiles.map((file, index) => (
                      <FileItem key={index}>
                        <FileInfo>
                          <img src="/images/file-icon.svg" alt="파일 아이콘" style={{ width: '18px', marginRight: '8px' }} />
                          <FileName>{file.name}</FileName>
                          {file.size > 0 && <FileSize>({formatFileSize(file.size)})</FileSize>}
                        </FileInfo>

                        <DeleteButton onClick={() => handleRemoveApkFile(index)}>
                          <FontAwesomeIcon icon={faTimes} />
                        </DeleteButton>
                      </FileItem>
                    ))}
                  </FileList>
                )}

              </AddImg>
              {
                gameProposalProjectInfoDetailsData?.rejections?.reasons?.apkGameFile !== '' && (
                  <>
                    <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                      * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.apkGameFile}
                      {/* APK 파일 반려 사유 */}
                    </span>
                  </>
                )
              }

              <div style={{ marginTop: '3%' }}>
                <SubTitle style={{ color: '#c0c0c0' }}>exe 파일 다운로드 형태 (PC)</SubTitle>
                <DisabledAddImg>
                  <DisabledPlus>+</DisabledPlus>exe 게임 파일 업로드
                </DisabledAddImg>
              </div>
            </>
          ) : platform === "PC" ? (
            <>
              <SubTitle style={{ color: '#c0c0c0' }}>APK 파일 다운로드 형태 (모바일)</SubTitle>
              <DisabledAddImg>
                <DisabledPlus>+</DisabledPlus>APK 게임 파일 업로드
              </DisabledAddImg>
              <SubTitle>exe 파일 다운로드 형태 (PC)</SubTitle>
              <AddImg onClick={!gameProposalStepAvailabilityData?.projectInfoSavable ? undefined : handleExeFileSelect}
                style={{
                  cursor: !gameProposalStepAvailabilityData?.projectInfoSavable ? 'not-allowed' : 'pointer',
                  borderColor: !gameProposalStepAvailabilityData?.projectInfoSavable ? '#CCCCCC' : '#2282E9',
                  color: !gameProposalStepAvailabilityData?.projectInfoSavable ? '#CCCCCC' : '#2282E9',
                  opacity: !gameProposalStepAvailabilityData?.projectInfoSavable ? 0.7 : 1
                }}
              >

                {exeFiles.length === 0 && (
                  <>
                    <Plus>+</Plus>
                    <span style={{ color: '#2282e9', fontWeight: 600 }}>exe 게임 파일 업로드</span>
                  </>
                )}
                {exeFiles.length > 0 && (
                  <FileList>
                    {exeFiles.map((file, index) => (
                      <FileItem key={index}>
                        <FileInfo>
                          <FileIcon icon={faFile} />
                          {/* <img src="/images/file-icon.svg" alt="파일 아이콘" style={{ width: '18px', marginRight: '8px' }} /> */}
                          <FileName>{file.name}</FileName>
                          {file.size > 0 && <FileSize>({formatFileSize(file.size)})</FileSize>}
                        </FileInfo>
                        <DeleteButton onClick={() => handleRemoveExeFile(index)}>
                          <FontAwesomeIcon icon={faTimes} />
                        </DeleteButton>
                      </FileItem>
                    ))}
                  </FileList>
                )}
              </AddImg>
              {
                gameProposalProjectInfoDetailsData?.rejections?.reasons?.exeGameFile !== '' && (
                  <>
                    <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                      * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.exeGameFile}
                      {/* EXE 파일 반려 사유 */}
                    </span>
                  </>
                )
              }
            </>
          ) : (
            <>
              <SubTitle style={{ color: 'black' }}>APK 파일 다운로드 형태 (모바일)</SubTitle>
              <AddImg onClick={!gameProposalStepAvailabilityData?.projectInfoSavable ? undefined : handleApkFileSelect}
                style={{
                  cursor: !gameProposalStepAvailabilityData?.projectInfoSavable ? 'not-allowed' : 'pointer',
                  borderColor: !gameProposalStepAvailabilityData?.projectInfoSavable ? '#CCCCCC' : '#2282E9',
                  color: !gameProposalStepAvailabilityData?.projectInfoSavable ? '#CCCCCC' : '#2282E9',
                  opacity: !gameProposalStepAvailabilityData?.projectInfoSavable ? 0.7 : 1
                }}
              >

                {apkFiles.length === 0 && (
                  <>
                    <Plus>+</Plus>
                    <span style={{ color: '#2282e9', fontWeight: 600 }}>APK 게임 파일 업로드</span>
                  </>
                )}
                {apkFiles.length > 0 && (
                  <FileList>
                    {apkFiles.map((file, index) => (
                      <FileItem key={index}>
                        <FileInfo>
                          <img src="/images/file-icon.svg" alt="파일 아이콘" style={{ width: '18px', marginRight: '8px' }} />
                          <FileName>{file.name}</FileName>
                          {file.size > 0 && <FileSize>({formatFileSize(file.size)})</FileSize>}
                        </FileInfo>
                        <DeleteButton onClick={() => handleRemoveApkFile(index)}>
                          <FontAwesomeIcon icon={faTimes} />
                        </DeleteButton>
                      </FileItem>
                    ))}
                  </FileList>
                )}
              </AddImg>
              {
                gameProposalProjectInfoDetailsData?.rejections?.reasons?.apkGameFile !== '' && (
                  <>
                    <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                      * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.apkGameFile}
                      {/* APK 파일 반려 사유 */}
                    </span>

                  </>
                )
              }
              <div style={{ marginBottom: '16px' }} />
              <SubTitle>exe 파일 다운로드 형태 (PC)</SubTitle>

              <AddImg onClick={!gameProposalStepAvailabilityData?.projectInfoSavable ? undefined : handleExeFileSelect}
                style={{
                  cursor: !gameProposalStepAvailabilityData?.projectInfoSavable ? 'not-allowed' : 'pointer',
                  borderColor: !gameProposalStepAvailabilityData?.projectInfoSavable ? '#CCCCCC' : '#2282E9',
                  color: !gameProposalStepAvailabilityData?.projectInfoSavable ? '#CCCCCC' : '#2282E9',
                  opacity: !gameProposalStepAvailabilityData?.projectInfoSavable ? 0.7 : 1
                }}
              >
                {exeFiles.length === 0 && (
                  <>
                    <Plus>+</Plus>exe 게임 파일 업로드
                  </>
                )}

                {exeFiles.length > 0 && (
                  <FileList>
                    {exeFiles.map((file, index) => (
                      <FileItem key={index}>
                        <FileInfo>
                          <img src="/images/file-icon.svg" alt="파일 아이콘" style={{ width: '18px', marginRight: '8px' }} />
                          <FileName>{file.name}</FileName>
                          {file.size > 0 && <FileSize>({formatFileSize(file.size)})</FileSize>}
                        </FileInfo>
                        <DeleteButton onClick={() => handleRemoveExeFile(index)}>
                          <FontAwesomeIcon icon={faTimes} />
                        </DeleteButton>
                      </FileItem>
                    ))}
                  </FileList>
                )}
              </AddImg>
              {
                gameProposalProjectInfoDetailsData?.rejections?.reasons?.exeGameFile !== '' && (
                  <>
                    <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                      * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.exeGameFile}
                      {/* EXE 파일 반려 사유 */}
                    </span>
                  </>
                )
              }
            </>
          )}
          <Bar />
          <Title>테스트 미션 설정</Title>
          <Comment>
            게임 플레이 후 1단계 설문 참여시 도달 미션을 설정해주세요.
            <br />
            상세하게 표시해주는 것이 좋습니다.
          </Comment>
          <div style={{ marginBottom: '16px' }} />
          <SubTitle>미션 설명 <span style={{ color: '#2282e9' }}> *</span></SubTitle>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <TextArea
              style={{
                height: "80px",
                // marginBottom: "40px",
                borderColor: !gameProposalStepAvailabilityData?.projectInfoSavable || isNotChangeable ? '#CCCCCC' : '#2282E9',
                color: !gameProposalStepAvailabilityData?.projectInfoSavable || isNotChangeable ? '#CCCCCC' : '#2282E9',
                backgroundColor: !gameProposalStepAvailabilityData?.projectInfoSavable || isNotChangeable ? '#F5F5F5' : 'white',
                cursor: !gameProposalStepAvailabilityData?.projectInfoSavable || isNotChangeable ? 'not-allowed' : 'text'
              }}
              placeholder="미션을 설명해주세요. 간단하고 명료하게 작성해주시는게 좋습니다. (ex. 상점 레벨 8까지 달성해주세요.)"
              {...register("missionDescription", {
                onChange: handleMissionDescriptionChange,
              })}
              disabled={!gameProposalStepAvailabilityData?.projectInfoSavable || isNotChangeable}
            />
            {
              // 테스트 미션 설명 반려 사유
              gameProposalProjectInfoDetailsData?.rejections?.reasons?.phaseOneDescription !== '' && (
                <>
                  <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                    * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.phaseOneDescription}
                    {/* phaseOneDescription 반려 사유 */}
                  </span>

                </>
              )
            }
            <div style={{ marginBottom: '40px' }} />
          </div>
          <Title>이미지 유형 선택 <span style={{ color: '#2282e9' }}> *</span></Title>
          <Comment>
            게임 이미지 방향이 세로형인지 가로형인지 선택해주세요.
          </Comment>
          <DirectionContainer>
            <input
              type="radio"
              id="vertical"
              value="세로형"
              {...register("direction")}
              style={{ display: "none" }}
              disabled={!gameProposalStepAvailabilityData?.projectInfoSavable || isNotChangeable}
              onChange={() => setValue("direction", "세로형")}
            />
            <Direction
              htmlFor="vertical"
              style={{
                opacity: !gameProposalStepAvailabilityData?.projectInfoSavable ? 0.7 : 1,
                cursor: !gameProposalStepAvailabilityData?.projectInfoSavable ? 'not-allowed' : 'pointer',
                backgroundColor: (() => {
                  const isNotSavable = !gameProposalStepAvailabilityData?.projectInfoSavable || isNotChangeable;
                  const isVertical = getValues("direction") === "세로형";

                  if (isNotSavable && isVertical) {
                    return '#8E8E8E';
                  } else if (isNotSavable && !isVertical) {
                    return 'white';
                  } else if (!isNotSavable && isVertical) {
                    return '#2282e9';
                  } else {
                    return 'white';
                  }
                })(),
                color: getValues("direction") === "세로형" ? 'white' : '#555555'
              }}
            >세로형</Direction>
            <input
              type="radio"
              id="horizontal"
              value="가로형"
              {...register("direction")}
              style={{ display: "none" }}
              disabled={!gameProposalStepAvailabilityData?.projectInfoSavable || isNotChangeable}
              onChange={() => setValue("direction", "가로형")}
            />
            <Direction
              htmlFor="horizontal"
              style={{
                opacity: !gameProposalStepAvailabilityData?.projectInfoSavable ? 0.7 : 1,
                cursor: !gameProposalStepAvailabilityData?.projectInfoSavable ? 'not-allowed' : 'pointer',
                backgroundColor: (() => {
                  const isNotSavable = !gameProposalStepAvailabilityData?.projectInfoSavable;
                  const isVertical = getValues("direction") === "세로형";

                  if (isNotSavable && isVertical) {
                    return 'white';
                  } else if (isNotSavable && !isVertical) {
                    return '#8E8E8E';
                  } else if (!isNotSavable && isVertical) {
                    return 'white';
                  } else {
                    return '#2282e9';
                  }
                })(),
                color: getValues("direction") === "가로형" ? 'white' : '#555555'
              }}
            >가로형</Direction>
          </DirectionContainer>

          <SubTitle>미션 예시 이미지 등록 <span style={{ color: '#2282e9' }}> *</span></SubTitle>
          <Comment>미션 확인 부분을 강조 해주시는 것을 추천드립니다.</Comment>
          <input
            type="file"
            accept=".jpeg, .png"
            onChange={(e) => phaseOneExampleImageChange(e)}
            style={{ display: "none" }}
            id="phaseOneExample"
            ref={(fileInput) => (fileInput = fileInput)}
          />
          {phaseOneExampleImage || phaseOneExampleImageUrl ? (
            <AddImg style={{
              alignItems: "stretch",
              borderColor: isDisabled || isNotChangeable ? '#CCCCCC' : '#2282E9',
              color: isDisabled || isNotChangeable ? '#CCCCCC' : '#2282E9',
              opacity: isDisabled || isNotChangeable ? 0.7 : 1,
              cursor: isDisabled || isNotChangeable ? 'not-allowed' : 'pointer'
            }}>
              <ImagesWrapper>
                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      backgroundColor: "#2282e9",
                      width: "20px",
                      height: "20px",
                      borderRadius: "999px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginLeft: "18px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faCheck}
                      style={{
                        color: "white",
                      }}
                    />
                  </div>

                  <ImagesContainer>
                    {phaseOneExampleImage ? (
                      <ThumbnailImg
                        src={URL.createObjectURL(phaseOneExampleImage)}
                        alt=""
                      />
                    ) : phaseOneExampleImageUrl ? (
                      <ThumbnailImg
                        src={phaseOneExampleImageUrl}
                        alt=""
                      />
                    ) : null}
                  </ImagesContainer>
                </div>
                {isDisabled || isNotChangeable ? null : <ImgChangeBtn
                  htmlFor="phaseOneExample"
                  style={{
                    borderColor: isDisabled || isNotChangeable ? '#CCCCCC' : '#ededed',
                    color: isDisabled || isNotChangeable ? '#CCCCCC' : '#797979',
                    cursor: isDisabled || isNotChangeable ? 'not-allowed' : 'pointer',
                    opacity: isDisabled || isNotChangeable ? 0.7 : 1
                  }}
                  onClick={(e) => {
                    if (isDisabled) {
                      e.preventDefault();
                    }
                  }}
                >
                  + 게임 이미지 변경하기
                </ImgChangeBtn>}
              </ImagesWrapper>
            </AddImg>
          ) : (
            <AddImg
              onClick={(e) => {
                if (isDisabled) {
                  e.preventDefault();
                  return;
                }
                document.getElementById('phaseOneExample')?.click();
              }}
              style={{
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                borderColor: isDisabled ? '#CCCCCC' : '#2282E9',
                color: isDisabled ? '#CCCCCC' : '#2282E9',
                opacity: isDisabled ? 0.7 : 1
              }}
            >
              <Plus style={{ color: isDisabled ? '#CCCCCC' : '#2282E9' }}>+</Plus>미션 이미지 추가하기
            </AddImg>
          )}
          {/* 희망 테스트 유저 수 반려 메시지 */}
          {gameProposalProjectInfoDetailsData?.rejections?.reasons?.phaseOneExampleImage !== '' &&
            <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
              * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.phaseOneExampleImage}
              {/* 반려 사유 */}
            </span>
          }
          {/* 간격 조절 */}
          <div style={{ marginBottom: '40px' }} />

          <GuideBox style={{ gap: "0px", height: "336px" }}>
            <div style={{ marginRight: "43px" }}>
              <GuideTitle>💡 GUIDE</GuideTitle>
              <GuideDesc>
                이미지를 등록했을시 <br />
                보여지는 화면 예시입니다!
                <br />
                참고하여 유형을 선택해
                <br />
                이미지를 추가해주세요.
              </GuideDesc>
            </div>
            <GuideImg style={{ marginRight: "28px" }}>
              <img
                src={GuideImg3}
                alt="img"
                style={{ width: "220px", height: "269px" }}
              />
              <span>» 가로형 이미지 적용 예시</span>
            </GuideImg>
            <GuideImg>
              <img
                src={GuideImg4}
                alt="img"
                style={{ width: "220px", height: "269px" }}
              />
              <span>» 세로형 이미지 적용 예시</span>
            </GuideImg>
          </GuideBox>
          <Bar />
          <Title>지급재화 <span style={{ color: '#2282e9' }}> *</span></Title>
          <Comment>
            테스트 참여시 유저에게 기본으로 지급되어야 하는 포인트는 1000 포인트
            입니다. <br />
            유저에게 지급되는 재화가 높을 수록 안정적인 테스터 모집과 높은 등급의
            유저와 매칭될 수 있습니다.
          </Comment>
          <div style={{
            position: "relative",
            width: "730px",
            display: "flex",
            alignItems: "center"
          }}>
            <Input
              type="text"
              value={rewardValue}
              onChange={handleRewardChange}
              onFocus={() => {
                if (isDisabled) return;
                if (rewardValue === "0") {
                  setRewardValue("");
                  setValue("reward", "");
                }
              }}
              onBlur={() => {
                if (isDisabled) return;
                if (rewardValue === "") {
                  setRewardValue("0");
                  setValue("reward", "0");
                }
              }}
              disabled={isDisabled || isNotChangeable}
              style={{
                borderColor: isDisabled || isNotChangeable ? '#CCCCCC' : '#2282E9',
                color: isDisabled || isNotChangeable ? '#CCCCCC' : '#2282E9',
                backgroundColor: isDisabled || isNotChangeable ? '#F5F5F5' : 'white',
                cursor: isDisabled || isNotChangeable ? 'not-allowed' : 'text',
                marginBottom: "0px",
                // flex: "1"
              }}
            />
            <PointSpan
              style={{
                color: isDisabled || isNotChangeable ? '#CCCCCC' : '#2282e9',
                marginLeft: "10px"
              }}
            >
              포인트
            </PointSpan>
          </div>

          {/* 지급재화 반려 사유 */}
          {gameProposalProjectInfoDetailsData?.rejections?.reasons?.rewards !== '' &&
            <>
              <span style={{ color: 'Red', fontSize: '13px', fontWeight: '400' }}>
                * 반려사유 : {gameProposalProjectInfoDetailsData?.rejections?.reasons?.rewards}
                {/* 반려 사유 */}
              </span>
              <div style={{ marginBottom: '16px' }} />
            </>
          }
          <CommentBlue>
            지급재화는 1000 포인트 이상으로 작성해야 하며, 1000 포인트 초과시 추가
            금액(차액x희망 유저 수)이 발생됩니다. <br />
            ex) 지급재화 1,500 포인트 / 희망 유저 수 50명 -&gt; 500x50 = 25,000
            추가금액 발생
          </CommentBlue>
        </ContentWrapper>
      </Main>

      {/* 모달 컴포넌트 */}
      {showSuccessModal && (
        <SuccessModal onClose={() => setShowSuccessModal(false)} />
      )}
      {showMoveModal && (
        <CheckPageMoveModal
          onClose={handleMoveCancel}
          onConfirm={handleMoveConfirm}
        />
      )}
    </>
  );
}